/* Change this file to get your personal Portfolio */

// Summary And Greeting Section

import emoji from "react-easy-emoji";

const illustration = {
  animated: false // set to false to use static SVG
};

const greeting = {
  username: "Voidbass",
  title: "Hi all, I'm Khoi",
  subTitle: emoji(
    "A passionate Front End Software Developer 🚀 having an experience of building Website with JavaScript / Reactjs / Vuejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://docs.google.com/document/d/1Ik6ypCSY1fHBWgJc6CMNNkd-r54pG81asZqxi9eGmy4/edit?usp=sharing",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/voidbass",
  linkedin: "https://www.linkedin.com/in/hu%E1%BB%B3nh-kh%C3%B4i-706572136/",
  gmail: "khoi.dn95@gmail.com",
  facebook: "https://www.facebook.com/voidbass/",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "FRONT END DEVELOPER WHO WANTS TO BECOME MERN STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your website"
    ),
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Vuejs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "Nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Strapi",
      fontAwesomeClassname: "fa fa-rocket"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "Nextjs",
      fontAwesomeClassname: "fa fa-play rotate-90"
    },
    {
      skillName: "git",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "figma",
      fontAwesomeClassname: "fab fa-figma"
    },
    {
      skillName: "jira",
      fontAwesomeClassname: "fab fa-jira"
    },
    {
      skillName: "bitbucket",
      fontAwesomeClassname: "fab fa-bitbucket"
    },
    {
      skillName: "gitlab",
      fontAwesomeClassname: "fab fa-gitlab"
    },
    {
      skillName: "LINUX",
      fontAwesomeClassname: "fab fa-linux"
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "VietNam-Korea College",
      logo: require("./assets/images/viet-han-logo.png"),
      subHeader: "Bachelor",
      duration: "January 2013 - June 2016",
      desc: "Knowledge about information technology",
    },
    {
      schoolName: "iViettech",
      logo: require("./assets/images/logo-iviettech.png"),
      subHeader: "Degree of FrontEnd Developer",
      duration: "January 2019 - June 2019",
      desc: "Understand more library and framework to apply any company",
    },
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "20%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Intern Front-End Developer",
      company: "Sun Asterisk",
      companylogo: require("./assets/images/sunasterisk-logo.jpg"),
      date: "May 2019 – August 2019",
      desc: "I'm learning ReactJS, HTML5, CSS3, PUGJS, SASS, Git and create 2 Projects at here",
      descBullets: [
        "Mandala Markup is written by PugJS and SASS",
        "Mandala ReactJS is written by ReactJS and SASS"
      ]
    },
    {
      role: "Fresher FrontEnd Developer",
      company: "Biti's",
      companylogo: require("./assets/images/bitis-logo.png"),
      date: "October 2019 – September 2020",
      descBullets: [
        "Knowledge using ReactJS, Ant Design",
        "Knowledge using REST Client",
        "Knowledge using Strapi to create API",
        "Knowledge to build API by Strapi & NodeJS, Mongoosejs",
        "Training for newbie",
      ]
    },
    {
      role: "Junior Front-End Developer",
      company: "NeoLab",
      companylogo: require("./assets/images/neolab-logo.jpg"),
      date: "October 2020 – November 2021",
      descBullets: [
        "Knowledge using Vue, VueX",
        "Knowledge using NuxtJS",
      ]
    },
    {
      role: "Middle Front-End Developer",
      company: "MOR",
      companylogo: require("./assets/images/mor-logo.png"),
      date: "November 2021 – June 2022",
      descBullets: [
        "Knowledge using Vue, VueX",
        "Training for newbie",
      ]
    },
    {
      role: "Middle Front-End Developer",
      company: "CMC Global",
      companylogo: require("./assets/images/cmc-logo.jpg"),
      date: "July 2022 – March 2023",
      descBullets: [
        "Knowledge using React, GraphQL",
        "Knowledge using NextJS",
        "Support team",
        "Review code",
        "Maintain big project",
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubConvertedToken: process.env.REACT_APP_GITHUB_TOKEN,
  githubUserName: "voidbass", // Change to your github username to view your profile in Contact Section.
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+84-762747405",
  email_address: "khoi.dn95@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  contactInfo,
  twitterDetails
};
